import './moreishkitchen/style';
import FormStructure from './moreishkitchen/form_structure';

export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/includes.js